// ***************************************
// MessagerDialog
//
// This is an empty template for a new component
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 25-9-2015
// ***************************************
import { tbEase } from "../engine/tbEase";
import { ComponentContainer } from "../framework/components/ComponentContainer";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { tgfComponents } from "../framework/components/tgfComponents";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfEffects } from "../framework/tgfEffects";
import { tgfGraphics } from "../framework/tgfGraphics";
import { tgfSettings } from "../framework/tgfSettings";
import { angrybirds_regular } from "./AssetDefinitions/FontDefinitions";
// Directives for jslint
/*global tbEase, tbVectorFont, tbGraphics, tbImage, tbSurface, tbGame */
/*global tgfComponents, tgfScale, tgfEffects, tgfDictionary, tgfAudio, tgfSettings */
tgfSettings.dialogDefaults.MessagerDialog =
    {
        queuedCallbacks: [],
        queuedCallbacksTimer: 0,
        isHidden: false,
        components: [] // Components to add as children
    };
// The constructor for the component
/**
 * @constructor
 * @base ComponentBase
 */
export var MessagerDialog = function (properties) {
    "use strict";
    this.name = "MessagerDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.container);
    this.setProperties(tgfSettings.dialogDefaults.MessagerDialog);
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base component
tgfComponents.inherit(MessagerDialog, DialogBase);
// Processing required when preparing the component for use
MessagerDialog.prototype.doPrepare = function () {
    "use strict";
};
MessagerDialog.prototype.showText = function (stringText, x, y, time, waitTime, callback) {
    "use strict";
    var _this = this;
    var idleTime = time / 1000 - 1;
    var startY = -100 - tgfGraphics.areaHeight / 2; // out of screen
    var self = this;
    var waitEffect = {
        effect: "nothing",
        duration: waitTime
    };
    var appearEffect = {
        effect: tgfEffects.move,
        duration: 0.5,
        startY: startY,
        endY: y,
        ease: tbEase.easeOutOvershoot,
        easeArgument: 1.2,
        name: "appear"
    };
    var nothingEffect = {
        effect: "nothing",
        duration: idleTime
    };
    var disappearEffect = {
        effect: tgfEffects.move,
        duration: 0.5,
        startY: y,
        endY: startY,
        ease: tbEase.easeInOvershoot,
        easeArgument: 1.2,
        name: "disappear"
    };
    this.newLabel = new ComponentContainer({
        x: x,
        y: -1000,
        effects: [
            waitEffect,
            appearEffect,
            nothingEffect,
            disappearEffect
        ],
        onEffectEnd: function () {
            this.effects = [];
            if (callback) {
                var modifiedCallback = function () {
                    if (!self.isHidden) {
                        self.newLabel.hide();
                        self.isHidden = true;
                    }
                    callback();
                };
                modifiedCallback();
            }
        },
    });
    var texts = stringText.split("<red>").join(",").split("</red>").join(",").split(",");
    var fillColors = ["#fefefe", "#ff0000", "#fefefe"];
    for (var i = 0; i < texts.length; i++) {
        var text = texts[i];
        var fillColor = fillColors[i];
        var label = new ComponentLabel({
            // This is a temporary "fix" for showing the text correctly until we have multistyle support back
            text: text,
            // alpha: 0,
            font: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 60,
                fillColor: fillColor,
                align: "center",
                baseline: "middle",
                shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 5, offsetY: 5, blur: 1, distance: 1 }
            }
        });
        this.newLabel.addComponent(label);
    }
    setTimeout(function () {
        var totalWidth = 0;
        for (var i = 0; i < _this.newLabel._components.length; i++) {
            var label = _this.newLabel._components[i];
            var prevLabel = _this.newLabel._components[i - 1];
            label.x = (prevLabel === null || prevLabel === void 0 ? void 0 : prevLabel.font.textWidth(prevLabel === null || prevLabel === void 0 ? void 0 : prevLabel.text)) / 2 + label.font.textWidth(label.text) / 2 + (prevLabel === null || prevLabel === void 0 ? void 0 : prevLabel.x) || 0;
            totalWidth += label.font.textWidth(label.text);
        }
        _this.newLabel.x += _this.newLabel._components[0].font.textWidth(_this.newLabel._components[0].text) / 2;
        _this.newLabel.x -= totalWidth / 2;
    }, 1);
    this.addComponent(this.newLabel);
    this.newLabel.show();
    this.newLabel.activate();
    this.newLabel.startSubEffect(0);
};
MessagerDialog.prototype.hideAllMessages = function (callback) {
    "use strict";
    var self = this;
    for (var index = 0; index < this._components.length; index++) {
        if (this._components[index].effectTime < this._components[index].effectDuration) {
            if (this._components[index].effectTime < 0.5) {
                this._components[index].effects = [];
                this._components[index].y = -1000;
            }
            else {
                this._components[index].startSubEffect(3);
            }
        }
    }
    // To replace the setTimeout
    if (callback) {
        var modifiedCallback = function () {
            if (!self.isHidden) {
                self.newLabel.hide();
                self.isHidden = true;
            }
            callback();
        };
        this.queuedCallbacks.push({
            timerMax: 1000,
            callback: modifiedCallback
        });
    }
};
MessagerDialog.prototype.handleEndStep = function (timeStep) {
    'use strict';
    if (this.queuedCallbacks.length > 0) {
        if (this.isHidden) {
            this.newLabel.show();
            this.isHidden = false;
        }
        this.queuedCallbacksTimer += timeStep;
        if (this.queuedCallbacksTimer > this.queuedCallbacks[0].timerMax) {
            this.queuedCallbacks[0].callback();
            this.queuedCallbacksTimer = 0;
            this.queuedCallbacks.shift();
        }
    }
    MessagerDialog.uber.handleEndStep.call(this, timeStep);
};
// Processing required when hiding the component
MessagerDialog.prototype.doHide = function () {
    "use strict";
};
